import { ComboboxItem, isOptionsGroup } from '@mantine/core';
import { OptionsGroup } from '@vision/ui/interfaces';

type LazyLoadSelectItem = ComboboxItem | OptionsGroup;

function getOptionValues(items: LazyLoadSelectItem[]): string[] {
  return items.flatMap((item) => (isOptionsGroup(item) ? item.items.map((child) => child.value) : [item.value]));
}

export function hasNewLazyLoadSelectItems(current: LazyLoadSelectItem[], next: LazyLoadSelectItem[]): boolean {
  const currentValues = new Set(getOptionValues(current));
  return getOptionValues(next).some((value) => !currentValues.has(value));
}

export function hasLazyLoadSelectItemValue(items: LazyLoadSelectItem[], value: string): boolean {
  return getOptionValues(items).includes(value);
}

export function mergeLazyLoadSelectItems(
  current: LazyLoadSelectItem[],
  next: LazyLoadSelectItem[],
): LazyLoadSelectItem[] {
  const merged: LazyLoadSelectItem[] = [];
  const groups = new Map<string, OptionsGroup>();
  const values = new Set<string>();

  current.concat(next).forEach((item) => {
    if (!isOptionsGroup(item)) {
      if (!values.has(item.value)) {
        values.add(item.value);
        merged.push(item);
      }
      return;
    }

    let group = groups.get(item.group);
    if (!group) {
      group = { group: item.group, items: [] };
      groups.set(item.group, group);
      merged.push(group);
    }

    item.items.forEach((child) => {
      if (!values.has(child.value)) {
        values.add(child.value);
        group.items.push(child);
      }
    });
  });

  return merged;
}
